import set from 'lodash/set';
import get from 'lodash/get';
import { getLocale } from '../translations/translator';

type IDTTRouteData = any;

export type RouteDataOptions = {
  routeName?: string;
  pathname?: string;
  bookCode: string;
  edition: string | number;
  locale?: string;
};

export type SavedPageParams = {
  pageNumber: number;
  singlePageView: boolean;
};
const storage = {
  get(itemName: string | number) {
    try {
      const serializedData = localStorage.getItem(itemName.toString());

      if (serializedData === null || serializedData === undefined) {
        return undefined;
      }

      return JSON.parse(serializedData);
    } catch (e) {
      return undefined;
    }
  },

  put(itemName: string | number, data: any) {
    try {
      localStorage.setItem(itemName.toString(), JSON.stringify(data));

      return { [itemName]: data };
    } catch (e) {
      // Do nothing
    }
  },

  remove(itemName: string | number) {
    try {
      localStorage.removeItem(itemName.toString());
    } catch (err) {
      // Do nothing
    }
  },

  clear() {
    try {
      localStorage.clear();
    } catch (err) {
      // Do nothing
    }
  }
};

export default storage;

export function saveRouteData(userId: number, routeData: RouteDataOptions): void {
  const { bookCode, edition, locale, pathname }: any = routeData;

  const update = storage.get(userId) || {};

  set(update, ['lastPath', locale], pathname);
  set(update, [edition, bookCode], pathname);

  //store student edition bookcode regardless
  set(update, ['lastProduct', locale], pathname.includes('/TG') ? bookCode.slice(2) : bookCode);

  const paths = pathname.split('/');
  if (paths.length && paths.length >= 5 && !isNaN(paths[4])) {
    set(update, ['lastPage', bookCode, 'pageNumber'], paths[4]);
    set(
      update,
      ['lastPage', bookCode, 'singlePageView'],
      paths.length >= 6 && paths[5] === 'zoom' ? true : false
    );
  }
  storage.put(userId, update);
}

export function getLastPathFor(userId: number, options?: RouteDataOptions): string | null {
  const idttData: IDTTRouteData = storage.get(userId);

  if (!idttData || !idttData.lastPath) return null;

  if (options) {
    const { bookCode, edition } = options;
    const getLastBookPath = () => get(idttData, [edition, bookCode]);

    return getLastBookPath();
  }
  return idttData.lastPath[getLocale()];
}

export function getLastPageForBookCode(
  userId: number | undefined,
  bookCode: string
): SavedPageParams {
  const idttData: IDTTRouteData = storage.get(userId as any);
  if (!idttData || !idttData.lastPage || !idttData.lastPage[bookCode])
    return { pageNumber: 0, singlePageView: false };

  const lastPage = idttData.lastPage[bookCode];
  const pageNumber = parseInt(lastPage.pageNumber);
  const singlePageView = JSON.parse(lastPage.singlePageView);
  return { pageNumber: isNaN(pageNumber) ? 0 : pageNumber, singlePageView: singlePageView };
}
export function saveLastProductUsed(userId: number, bookCode: string, locale: string) {
  const update = storage.get(userId) || {};
  set(update, ['lastProduct', locale], bookCode);
  storage.put(userId, update);
}

export function clearLocalStorage(): void {
  storage.clear();
}
